<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title"><i class="fas fa-user-lock"></i> {{title | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="siecredentialForm">
      <div class="form-group" *ngIf="hasRole(ROLE_SUPERADMIN)">
        <label class="font-weight-bold">{{ "LABEL.PARTNER" | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fa fa-university" aria-hidden="true"></i></div>
          </div>
          <select class="form-control ml-1 custom-width-select"
                  [(ngModel)]="partnerSelected"
                  (ngModelChange)="reloadEnterprises()"
                  formControlName="partner">
            <option *ngFor="let partner of partners" [ngValue]="partner">{{partner.name | translate}}</option>
          </select>
        </div>
      </div>
      <div class="form-group" *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)">
        <label class="font-weight-bold" for="enterpriseInput">{{ "LABEL.ENTERPRISE" | translate }}</label>
        <div class="input-group">
          <div class="input-group-prepend">
            <div class="input-group-text"><i class="fa fa-building" aria-hidden="true"></i></div>
          </div>
          <select id="enterpriseInput"
                  class="form-control"
                  formControlName="enterprise"
                  [(ngModel)]="siecredential.enterpriseId"
                  (ngModelChange)="loadUsername()">
            <option *ngFor="let enterprise of enterprises"
                    [ngValue]="enterprise.id">{{enterprise.name | translate}}</option>
          </select>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-7">
          <label for="inputUserSie">{{ "LABEL.USER" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-user" aria-hidden="true"></i></div>
            </div>
            <input type="text"
                   class="form-control"
                   id="inputUserSie"
                   placeholder="{{ 'MESSAGE.ENTER-USER' | translate }}"
                   formControlName="usernameSie"
                   [class.is-invalid]="isInvalidControl('usernameSie')">
          </div>
        </div>
        <div class="form-group col-md-5">
          <label for="inputPasswordSie">{{ "LABEL.PASSWORD" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-lock" aria-hidden="true"></i></div>
            </div>
            <input type="password"
                   class="form-control"
                   id="inputPasswordSie"
                   placeholder="{{ 'MESSAGE.ENTER-PASSWORD' | translate }}"
                   formControlName="passwordSie"
                   [class.is-invalid]="isInvalidControl('passwordSie')">
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-md-7">
          <label for="inputUserSie">{{ "LABEL.CERTIFICATE" | translate }}</label>
          <div class="padding-select-file">
            <div class="custom-file content-file">
              <input type="file" class="custom-file-input w-100 content-file" accept=".p12"
                     id="certificate" (change)="changeStatus($event)"
                     [class.is-invalid]="isInvalidControl('certificate')">
              <label class="custom-file-label"
                     for="certificate">
                {{siecredentialForm.get('certificateName').value ? siecredentialForm.get('certificateName').value : ("MESSAGE.SELECT" | translate)}}
              </label>
            </div>
          </div>
        </div>
        <div class="form-group col-md-5">
          <label for="inputPasswordSie">{{ "LABEL.PASSWORD-CERTIFICATE" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-lock" aria-hidden="true"></i></div>
            </div>
            <input type="password"
                   class="form-control"
                   id="inputPasswordCertificate"
                   placeholder="{{ 'MESSAGE.ENTER-PASSWORD' | translate }}"
                   formControlName="passwordCertificate"
                   [class.is-invalid]="isInvalidControl('passwordCertificate')">
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="save()">
      <i class="fa fa-bookmark"></i> {{ "BUTTON.SAVE" | translate }}
    </button>
    <button type="button" class="btn btn-outline-danger" (click)="cancel()">
      <i class="fa fa-times-circle"></i> {{ "BUTTON.CANCEL" | translate }}
    </button>
  </div>
</div>
<app-loading *ngIf="loading"></app-loading>
